import React from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { faMapPin } from '@fortawesome/free-solid-svg-icons';

import ClickableIcon from '~components/ClickableIcon';

import Legend from '../Legend';

interface ComponentProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LegendDropdown: React.FC<ComponentProps> = ({ isOpen, setIsOpen }) => {
  return (
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} direction="down">
      <DropdownToggle size="sm" className="banner-icon">
        <ClickableIcon id="legend-toggle" icon={faMapPin} toolTip="Icon Legend" />
      </DropdownToggle>
      <DropdownMenu className="legend-dropdown-menu">
        <Legend />
      </DropdownMenu>
    </Dropdown>
  );
};

export default LegendDropdown;
